import React from "react";
import { useSelector } from 'react-redux';
import { SiteTitle } from "../theme/theme";
import { Link } from "react-router-dom";

const Header = ()=>{
    const data = useSelector(state=>state.data.data)

    if (!data){
        return null;
    }

    return <Link  to="/"><div style={{textAlign: "center"}}>
        <SiteTitle>{data.title}</SiteTitle>
    </div></Link>
}

export default Header;